import { IOS_REGEXP } from '../constants/constants';

export const clipboardMixin = {
	methods: {
		copyToClipboard(text) {
			const textArea = document.createElement('textarea');
			const yPosition = window.pageYOffset || document.documentElement.scrollTop;
			textArea.style.fontSize = '12pt';
			textArea.style.border = '0';
			textArea.style.padding = '0';
			textArea.style.margin = '0';
			textArea.style.position = 'absolute';
			textArea.style.left = '-9999px';
			textArea.style.top = `${yPosition}px`;
			textArea.value = text;
			textArea.readOnly = true;
			document.body.appendChild(textArea);
			if (navigator.userAgent.match(IOS_REGEXP)) {
				let range = document.createRange();
				range.selectNodeContents(textArea);
				let selection = window.getSelection();
				selection.removeAllRanges();
				selection.addRange(range);
				textArea.setSelectionRange(0, 999999);
			} else {
				textArea.select();
			}
			document.execCommand('copy');
			document.body.removeChild(textArea);
		}
	}
};
